import router from './router'
import store from './store/index';
import { cacheChildren } from './router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';


NProgress.inc(0.2)
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })

router.beforeEach((to, from, next) => {
  if (store.state.cachePages.indexOf(to.name) === -1) {
    NProgress.start();
  }
  const cacheChildrenStr = cacheChildren.map(item => item.name);
  if (cacheChildrenStr.indexOf(to.name) > -1) {
    store.commit({ type: 'addCachePage', component: to });
  }
  store.commit({ type: 'setCurrentPage', component: to });
  next();
})

router.afterEach(() => {
  NProgress.done();
});